import { message } from "antd";

export const useMessageUtils = () => {
    const [messageApi, contextHolder] = message.useMessage();

    const showMessage = (type, content, duration) => {
        messageApi.open({
            key: 'msgKey',
            type: type,
            content: content,
            duration: duration,
        });
    };

    const closeMessage = () => {
        message.destroy('msgKey');
    };

    return { showMessage, closeMessage, contextHolder };
};